import React from 'react'
import { Link } from 'react-router-dom'

function OverflowOption(item: PivotBaseItem | Rule,
    icon: JSX.Element,
    label: string,
    linkFunction: (e: any, item: PivotBaseItem | Rule) => void) {
    return (
        <div className={`tw-py-1 tw-border `} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            <Link to="#" onClick={(e) => linkFunction(e, item)} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-[#172b4d]  hover:tw-bg-[#F0F3FE] `} role="menuitem">
                <div className="tw-flex">
                    <div className="tw-mt-1">{icon}</div>
                    <span className="tw-ml-1">{label}</span>
                </div>
            </Link>
        </div>
    )
}

export default OverflowOption

